import WhatsAppIcon from '../../assets/icons/whatsapp.svg'
import FacebookIcon from '../../assets/icons/facebook.svg'
import MailIcon from '../../assets/icons/mail.svg'
import SuccessIcon from '../../assets/icons/circle-check-solid.svg'

const Success = () => {
  return (
    <div
      id="slide-phone-consult-success"
      className="phone-consult-success slide slide--consult"
    >
      <div className="slide__sections slide__sections--center slide__sections--text-center-full">
        <div className="slide__section">
          <span className="form-submit-title">Success!</span>
          <img
            src={SuccessIcon}
            alt="success icon"
            className="form-submit-icon"
          />
          <br />
          <span>Thank you for booking your free phone consultation!</span>
          <br />
          <span>You should receive a confirmation message shortly.</span>
          <span>In the meantime should you have any questions,</span>
          <span>feel free to reach out to me via social media.</span>
          <br />
          <span>Talk to you soon!</span>
          <br />
          <div className="social-links-wrapper">
            <a href="https://wa.me/14808153372" target="_blank">
              <img
                className="social-image"
                src={WhatsAppIcon}
                alt="whatsapp icon"
              />
            </a>
            <a href="http://m.me/carah.robenalt" target="_blank">
              <img
                className="social-image"
                src={FacebookIcon}
                alt="facebook icon"
              />
            </a>
            <a href="mailto:carahmollerup@gmail.com" target="_blank">
              <img className="social-image" src={MailIcon} alt="email icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Success
